import React from "react";
import { Route, Redirect } from "react-router-dom";

function ProtectedChildRoute({ ...rest }) {

    const isAuthenticated = localStorage.getItem('authToken')
    const role = localStorage.getItem('role')

    if (role == 3 && isAuthenticated || role == 4 && isAuthenticated)
        return <Route {...rest} />
    else return <Redirect to="/404" />
};

export default ProtectedChildRoute;